import{useSelector as t}from"react-redux";const o=()=>t(e=>e.base);export{o as useBaseState};
